import React, {Component} from 'react'
import Header from "../components/header"
import Footer from "../components/footer"
import '../../static/css/style.scss'
import CardItem from "../components/cardItem"
class Singapore extends Component {
	state={
		youshi:[
			{
				name:'环境相当安全',
				content:'新加坡的法律健全，国民素质高比起美国的合法持枪，比起日本环境的杂乱，比起韩国的整容风气，新加还是比较传统风气的社会风范，还自己家长完全可以放心孩子到新加坡留学。',
			},
			{
				name:'教育体制同世界接轨，获得的文凭及学位受国际认可',
				content:'新加坡的教育目标是为每一个人提供均衡的教育，坚持因材施教的原则，充分发挥每个人的潜能。由新加坡教育部注册合格的语言或专业教师负责授课，加上现代化的教育设施，为留学生提供高水准的师资保证。',
			},
			{
				name:'因为语言和文化的隔阂造成的心理问题较少',
				content:'留学欧美的很多学生面临着文化不适应，如果语言不够好造成交流问题，一些人只跟中国留学生交住，约有三分之一的人因此造成心理上的问题。严重的甚至导致人格分化，而新加坡当地每天可以看到大量的华人，天天听华文，所有华人的节日，新加坡都过得比中国更像传统的中国。',
			},
			{
				name:'费用低廉，公立学校有政府津贴',
				content:'新加坡的费用（生活费、学费）相对英国、澳洲、美国便宜，学生可以在投资最小的情况下获得最大的收获，留学费用和生活费用低。一年总费用需要10-15万人民币。若被新加坡政府理工学院、大学录取，中国学生可获得高达80%政府学费津贴。',
			},
			{
				name:'学校众多，教育课程选择广泛，容易申请',
				content:'新加坡除了政府学校以外，还有众多的私立院校，这些私立院校受新加坡政府监管，通过一系列认证制度选拔出来，招收国际学生，并为国际学生提供英文课程，没有雅思和托福也可以申请。学校众多的另一优势是开办的课程类型广泛，横跨不同的学科与专业，不论是学术研究、体育、商科、管理、或是艺术课程，所有学生都有机会根据自己的兴趣选择适合的课程，且学位丰富。',
			},
			{
				name:'就业前景',
				content:'在这里完成了学业之后，大家准备就业也不用过于担心，留在新加坡求职的话，可以直接申请求职的临时居留求职，最长可以申请一年的时间，时间是非常充足的，在这里也可以进行其他国家企业的求职。<br><br> 如果准备回国，要记得做好学历的认证，这样自己的学历才会被认可，并且可以享受国内政府提供给留学生的各种福利，有了海归身份的加持，大家的薪资也会更高一些。',
			},
		],
		zhuanye:[
			{
				title:'酒店与旅游管理专业',
				content:'酒店与旅游管理专业在新加坡就业市场的需求潜力很大。因为新加坡拥有发达的酒店和旅游产业，堪称亚太地区的旅游酒店中心。新加坡的酒店业在整个亚洲排名，旅游业排名亚洲第三。\n' +
					'目前，当地缺少4-5万旅游酒店业的从业者，这就为移民新加坡的中国留学生提供了非常好的契机。随着新加坡建成的两座亚洲最大的综合度假城落成之后，预计每年会新增数万个就业机会。<br><br> 推荐院校：新加坡ERC创业管理学院、新加坡MDIS学院',
				img:require('../../static/images/singapore03.jpg')
			},
			{
				title:'金融管理专业',
				content:'新加坡作为亚太地区的金融中心，拥有超过800加金融机构，并且多数银行都在新加坡设立总部。这两个专业的毕业生可以很快在新加坡本地找到工作，可从事的行业包括外资银行、金融机构、证券公司、' +
					'审计机构及国际贸易公司等领域。工作两年后再回国发展，一定是中国紧缺型人才，前途广泛。<br><br> 推荐院校：新加坡东亚管理学院（EASB）、新加坡Kaplan学院',
				img:require('../../static/images/singapore04.jpg')
			},
			{
				title:'大众传媒专业',
				content:'每年20%的人才需求增长、30%的薪资增长，使传媒专业成为国内高校的报考大热门。新加坡是亚太地区的资讯中心，高等院校的大众传媒专业实力强劲，专业方向涉及数字电视、多媒体、互联网等新兴传媒领域。',
				img:require('../../static/images/singapore05.jpg')
			},
			{
				title:'物流管理专业',
				content:'新加坡是国际著名的金融贸易和海运、航运中心，也是亚太地区最大的物流枢纽，世界著名的物流企业都在新加坡设立区域总部。随着经济全球化和贸易自由化的延伸和深化，物流将变得越来越重要。经济越发达，贸易越活跃，' +
					'物流越显得重要和不可或缺。因此新加坡留学热门专业的选取和经济发展相关的。<br><br>物流产业已经被列为中国四大新兴产业之一，相关岗位的需求量以每年15%-20%的速度增长。' +
					'新加坡拥有全球第二大港口，发达的行业对人才的需求量居高不下。新加坡留学院校如：新加坡物流管理学院，新加坡楷博高等教育学院。',
				img:require('../../static/images/singapore06.jpg')
			},
		]
	}
	render() {
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<img className={'banimg'} src={require('../../static/images/singapore01.jpg')} alt=""/>
					<div className={'content'}>
						<div className={'title'}>
							<span>新加坡简介</span>
							<span className={'line'}/>
						</div>
						<div className={'contentModule'}>
							<div className={'text textJust'}>
								新加坡是东南亚的一个岛国，也是一个城市国家，位于马来半岛南端。新加坡是亚洲最重要的金融、服务和航运中心之一。新加坡在城市保洁方面效果显著，故亦有“花园城市”之美称。
									<br/><br/>
								新加坡教育制度类似英国式制度。新加坡的教育制度强调双语、体育、道德教育、创新和独立思考能力并重。双语政策要求学生除了学习变文，还要兼通母语（华文）。学校的公立学校包括170所小学、154所中学、14所初级学院，以及新加坡国立大学、南洋理工大学和管理大学三所大学和五所理工学院南洋理工学院，义安理工学院，新加坡理工学院，淡马锡理工学院，共和理工学院。新加坡是亚洲留学大国，吸引东南亚、中国及世界其他国家学生前往深造，其中中国学生约有三分之一。新加坡有数量众多的私立教育机构，与其他国家的大学联办，为本地和留学生提供高等教育课程。</div>
							<img className={'img'} src={require('../../static/images/singapore02.jpg')} alt=""/>
						</div>
						<div className={'title'}>
							<span>新加坡留学优势</span>
							<span className={'line'}/>
						</div>
						<div className={'textModule'}>
							{
								this.state.youshi.map((item,index)=>(
									<div className={'textModuleItem'} key={index}>
										<div className={'textModuleItemFlexWrap'}>
											<div className={'textModuleItemTitle'}>{item.name}</div>
											<div className={'textModuleItemText textJust'} dangerouslySetInnerHTML={{__html:item.content}}/>
										</div>
									</div>
								))
							}
						</div>
						<div className={'title'}>
							<span>新加坡留学热门专业</span>
							<span className={'line'}/>
						</div>
						<div className={'zhuanye'}>
							{
								this.state.zhuanye.map((item,index)=>(
									<CardItem item={item} key={index}/>
								))
							}
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Singapore